/**
 * Detect memory exhaustion and show warning.
 */
export default class WpstgDetectMemoryExhaust {
  constructor(
      wpstgObject = wpstg,
  ) {
    this.wpstgObject = wpstgObject;
  }

  async sendRequest(requestType) {
    try {
      const response = await fetch(this.wpstgObject.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: new URLSearchParams({
          action: 'wpstg--detect-memory-exhaust',
          requestType: requestType,
          accessToken: this.wpstgObject.accessToken,
          nonce: this.wpstgObject.nonce,
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      const data = await response.json();

      if ('undefined' !== typeof (data.status) && data.status && data.error) {
        return data;
      }

      console.warn(data.message);
    } catch (error) {
      console.warn(this.wpstgObject.i18n['somethingWentWrong'], error);
    }

    return false;
  }
}
